import React, { useState, useMemo, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import get from 'lodash/get'
import set from 'lodash/set'

import { useMutation, updateQuery } from 'components/graphql'
import mutationDel from 'gql/mutation/updateSpecialPrice'
import { getProduct } from '../../gql/query'
import PriceDetails from './PriceDetails'
import { ContentBlock } from 'components/ContentBlock'
import { DataTable } from 'components/DataTable'
import { price } from '../../tableColumns'
import Print from '../../../../components/Print/Print'
import {
	generatePDFAllSpecialOffers,
	generatePdfPrices
} from '../../gql/mutation/generatePdfPrices'
import { StyledPrintButton } from './StyledComponents'

const Price = ({ data = {} }) => {
	const [priceData, setPriceData] = useState(null)
	const [mutate] = useMutation(mutationDel)
	const [t] = useTranslation()

	const columns = useMemo(() => price(t))
	const defaultDataForNew = {
		type: 2,
		id: -1,
		mode: 0,
		dateInterval: { from: moment().utc().startOf('day').format(), to: null },
		timeInterval: { from: moment.utc('1899-12-30').startOf('day').format(), to: moment.utc('1899-12-30T23:59:00').format() },
		actionAmount: {},
		actionGroup: null,
		weekDays: 127,
		price: data && Array.isArray(data.price) ? data.price.map(item => item || null) || [] : [],
		priceInCafe: data && Array.isArray(data.priceInCafe) ? data.priceInCafe.map(item => item || null) || [] : [],
		codeMWSt:  data?.codeMWSt || 'normal',
		codeMWSt2: data?.codeMWSt2 || 'normal'

	}
	const tableTitlesForPrint = {
		productCode: t('product_section.fields.number'),
		productName: t('product_section.fields.description'),
		type: t('product_section.strings.type'),
		fromDate: t('common.fields.from_date'),
		toDate: t('common.fields.to_date'),
		name: t('product_section.fields.name'),
		priceOutCafe: t('product_section.strings.price_out_cafe'),
		priceInCafe: t('product_section.strings.price_in_cafe') }

	const closeDetails = () => setPriceData(null)
	const { specialPrices = [] } = data
	return(
		<Fragment>
			<ContentBlock label={t('product_section.strings.prices_label')}>
				<StyledPrintButton>
					<Print withTimePeriod tableTitles={tableTitlesForPrint} withMaxDate={false} mutationPdf={generatePdfPrices} mutationPDFWithTimePeriod = {generatePDFAllSpecialOffers} urlPath='generatePdfPrices' urlPathWithTimePeriod='generatePDFAllSpecialOffers' dataCurrentJson={data} />
				</StyledPrintButton>
				<DataTable
					data={specialPrices?.filter?.(item => item) || []}
					columns={columns}
					withSearch
					selectRow
					onRowClick={(state, { original }) => setPriceData(original)}
					mutateRow={{
						onRowMutate: id => {
							mutate({
								variables: { id, fields: { isActive: false } },
								update: updateQuery({ query: getProduct, variables: { id: data.id } }, (draft, { mutationResult, readQuery = {}, queryField }) => {
									const oldPrices = get(readQuery, 'specialPrices', [])
									const newPrices = oldPrices.filter((item = {}) => item.id.toString() !== id.toString())
									set(draft, [queryField, 'specialPrices'], newPrices)
								})
							})
							if(priceData && priceData.id === id) {
								closeDetails()
							}
						}
					}}
					onAddRecord={() => setPriceData(defaultDataForNew)}
				/>
			</ContentBlock>
			{priceData &&
				<PriceDetails
					key={priceData.id}
					priceData={priceData}
					productId={data.id}
					onSubmit={closeDetails} />
			}
		</Fragment>
	)
}

export default Price
